export default __webpack_public_path__ + "static/media/iModXCompany.8b2725de.gif";